import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetReducer(state = initialState.budget, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGET_SUCCESS:
      return action.budget;
    default:
      return state;
  }
}
